import { useRef, useEffect, useState } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import './style.scss'
import GlassEffect from "../GlassEffect/GlassEffect";
import MyButton from "../../../../../components/UI/button/MyButton";
import ProLevelCard from "./ProLevelCard";
gsap.registerPlugin(ScrollTrigger);

export default function ProLevel({ handleClick, isVisible }) {
    const ref = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {
        const cards = gsap.utils.toArray(".stackCard");
        const createTriggers = () => {
            cards.forEach((card, i) => {

                const cardHeight = card.offsetHeight;
                const max = 100;
                const lastIndex = cards.length - 1
                const bottom = lastIndex - 1 === i
                    ? `20rem`
                    : `${3 * cardHeight}px`;
                const parentCard = card.closest('.landing-prolevel-card--3');

                if (lastIndex !== i) {
                    ScrollTrigger.create({
                        trigger: parentCard,
                        start: `"top+=0 top+=${max}rem"`,
                        end: `bottom+=${bottom} top+=${max}rem`,
                        pin: true,
                        pinSpacing: false,
                        // markers: i === 4,
                        scrub: true,

                    });
                }
            });

            cards.forEach((card, i) => {
                if (i === 0) return;

                const prevCard = cards[i - 1];
                const parent = prevCard.closest('.landing-prolevel-card--2');
                const max = 100;

                ScrollTrigger.create({
                    trigger: card,
                    start: `"top+=0 top+=${max + 220}rem"`,
                    end: `"top+=0 top+=${max}rem"`,
                    scrub: true,

                    onUpdate: (self) => {

                        gsap.to(parent, {
                            scale: 1 - 0.05 * self.progress,
                            y: (-8 * self.progress) + 'rem',
                            transformOrigin: "top center",
                            ease: "none"
                        });
                    }
                });
            });
            cards.forEach((card, i) => {
                if (i === 0 || i === 1) return;

                const prevCard = cards[i - 2];
                const parent = prevCard.closest('.landing-prolevel-card--1');
                const max = 100;

                ScrollTrigger.create({
                    trigger: card,
                    start: `"top+=0 top+=${max + 220}rem"`,
                    end: `"top+=0 top+=${max}rem"`,
                    scrub: true,
                    markers: i === 1,
                    onUpdate: (self) => {
                        gsap.to(parent, {
                            scale: 1 - 0.05 * self.progress,
                            y: (-8 * self.progress) + 'rem',
                            transformOrigin: "top center",
                            ease: "none"
                        });
                    }
                });
            });
            cards.forEach((card, i) => {
                if (i === 0 || i === 1 || i === 2) return;

                const prevCard = cards[i - 3];
                const parent = prevCard.closest('.landing-prolevel-card--0');
                const max = 100;

                ScrollTrigger.create({
                    trigger: card,
                    start: `"top+=0 top+=${max + 220}rem"`,
                    end: `"top+=0 top+=${max}rem"`,
                    scrub: true,
                    markers: i === 1,
                    onUpdate: (self) => {
                        gsap.to(parent, {
                            scale: 1 - 0.05 * self.progress,
                            y: (-8 * self.progress) + 'rem',
                            opacity: 1 - self.progress,
                            transformOrigin: "top center",
                            ease: "none"
                        });
                    }
                });
            });
            cards.forEach((card, i) => {
                const lastIndex = cards.length - 1
                if (i !== lastIndex) return;

                const prevCard = cards[i - 1];
                const prev2Card = cards[i - 2];
                const parent = prevCard.closest('.landing-prolevel-card--final');
                const parent2 = prev2Card.closest('.landing-prolevel-card--final');
                const max = 100;


                ScrollTrigger.create({
                    trigger: card,
                    start: `"top+=0 top+=${max}rem"`,
                    end: `bottom top`,
                    scrub: true,
                    onUpdate: (self) => {
                        gsap.to(parent, {
                            y: (0 * self.progress) + 'rem',
                            transformOrigin: "top center",
                            ease: "none",
                            duration: 0
                        });
                        gsap.to(parent2, {
                            y: (-320 * self.progress) + 'rem',
                            transformOrigin: "top center",
                            ease: "none",
                            duration: 0
                        });
                    }
                });
            });

            cards.forEach((card, i) => {
                const max = 100;

                ScrollTrigger.create({
                    trigger: card,
                    start: `"top+=0 top+=${max + 220}rem"`,
                    end: `"top+=0 top+=${max}rem"`,
                    scrub: true,
                    onUpdate: () => {
                        setActiveIndex(i)
                    }
                });
            });


        }
        if (!isVisible) createTriggers();

    }, [isVisible]);


    return (
        <div
            ref={ref}
            style={{
                position: "relative",
                overflow: 'hidden'
            }}
            data-theme="dark"
        >
            <div className="landing-prolevel">
                <div className="landing-container">
                    <h2 dangerouslySetInnerHTML={{ __html: isVisible ? 'Try pro-level AI models on your ideas' : 'Try pro-level AI models<br> on your ideas' }}></h2>
                    {isVisible ? <div className="landing-prolevel-container" key={isVisible ? 'descktop' : 'mobile'}>
                        <ProLevelCard isVisible={isVisible} source={'button_10'} handleClick={handleClick} icon={'landing/pl1.svg'} img={'landing/pl1.webp'} video={'pl1.mp4'} aspectRatio={'760/558'} text={'Creates cinematic stories with rich, fluid motion'} />
                        <ProLevelCard isVisible={isVisible} source={'button_11'} handleClick={handleClick} icon={'landing/pl2.svg'} img={'landing/pl2.webp'} video={'pl2.mp4'} aspectRatio={'760/1330'} text={'Makes social videos with big, built-in sound'} />
                        <ProLevelCard isVisible={isVisible} source={'button_12'} handleClick={handleClick} icon={'landing/pl3.svg'} img={'landing/pl3.webp'} video={'pl3.mp4'} aspectRatio={'760/554'} text={'Great for surreal visuals with deep, dreamlike detail'} />
                        <ProLevelCard isVisible={isVisible} source={'button_13'} handleClick={handleClick} icon={'landing/pli4.webp'} img={'landing/pl4.webp'} video={'pl4.mp4'} aspectRatio={'760/562'} text={'Perfect for punchy promos with turbo-speed motion'} />
                        <ProLevelCard isVisible={isVisible} source={'button_14'} handleClick={handleClick} icon={'landing/pl5.svg'} img={'landing/pl5.webp'} video={'pl5.mp4'} aspectRatio={'760/576'} text={'Creates high-end visuals with deep, realistic texture'} />
                        <ProLevelCard isVisible={isVisible} source={'button_15'} handleClick={handleClick} icon={'landing/pl6.svg'} img={'landing/pl6.webp'} video={'pl6.mp4'} aspectRatio={'760/432'} text={'Gives you eye-popping shots with crisp, vivid detail'} />
                        <ProLevelCard isVisible={isVisible} source={'button_16'} handleClick={handleClick} icon={'landing/pl7.svg'} img={'landing/pl7.webp'} video={'pl7.mp4'} aspectRatio={'760/570'} text={'Makes rhythm-first clips with smooth, dance-like flow'} />
                        <ProLevelCard source={'button_17'} title={'All new models'} handleClick={handleClick} text={'Creates cinematic stories with rich, fluid motion'} />
                    </div> : <div className="landing-prolevel-container" key={isVisible ? 'descktop' : 'mobile'}>
                        <ProLevelCard autoplay={activeIndex === 0} isVisible={isVisible} source={'button_10'} handleClick={handleClick} icon={'landing/pl1.svg'} img={'landing/pl1.webp'} video={'pl1.mp4'} aspectRatio={'760/558'} text={'Creates cinematic stories with rich, fluid motion'} />
                        <ProLevelCard autoplay={activeIndex === 1} reverse={true} isVisible={isVisible} source={'button_11'} handleClick={handleClick} icon={'landing/pl2.svg'} img={'landing/pl2.webp'} video={'pl2.mp4'} aspectRatio={'760/1330'} text={'Makes social videos with big, built-in sound'} />
                        <ProLevelCard autoplay={activeIndex === 2} isVisible={isVisible} source={'button_12'} handleClick={handleClick} icon={'landing/pl3.svg'} img={'landing/pl3.webp'} video={'pl3.mp4'} aspectRatio={'760/554'} text={'Great for surreal visuals with deep, dreamlike detail'} />
                        <ProLevelCard autoplay={activeIndex === 3} reverse={true} isVisible={isVisible} source={'button_13'} handleClick={handleClick} icon={'landing/pli4.webp'} img={'landing/pl4.webp'} video={'pl4.mp4'} aspectRatio={'760/562'} text={'Perfect for punchy promos with turbo-speed motion'} />
                        <ProLevelCard autoplay={activeIndex === 4} isVisible={isVisible} source={'button_14'} handleClick={handleClick} icon={'landing/pl5.svg'} img={'landing/pl5.webp'} video={'pl5.mp4'} aspectRatio={'760/576'} text={'Creates high-end visuals with deep, realistic texture'} />
                        <ProLevelCard autoplay={activeIndex === 5} reverse={true} isVisible={isVisible} source={'button_15'} handleClick={handleClick} icon={'landing/pl6.svg'} img={'landing/pl6.webp'} video={'pl6.mp4'} aspectRatio={'760/432'} text={'Gives you eye-popping shots with crisp, vivid detail'} />
                        <ProLevelCard autoplay={activeIndex === 6} isVisible={isVisible} source={'button_16'} handleClick={handleClick} icon={'landing/pl7.svg'} img={'landing/pl7.webp'} video={'pl7.mp4'} aspectRatio={'760/570'} text={'Makes rhythm-first clips with smooth, dance-like flow'} />
                        <ProLevelCard reverse={true} source={'button_17'} title={'All new models'} handleClick={handleClick} text={'Creates cinematic stories with rich, fluid motion'} />
                    </div>}

                </div>
            </div>
        </div>
    );
}
